import { usePushGetHelp } from "@medbillai/app/lib/usePushGetHelp";
import { Paragraph2, Separator, XStack } from "@medbillai/ui";
import { Flag } from "@medbillai/utils/flag";
import { BillHelpBadge, CoverageCheckBadge, OpenEnrollmentBadge, SomethingElseBadge } from "../../../components/local-images";
import { useBoolVariation } from "../../../lib/flag";
import { GetHelpPrompt } from "./GetHelpPrompt";
import { WidgetWrapper } from "./WidgetWrapper";
export function GetHelpPrompts() {
  const {
    pushGetHelp
  } = usePushGetHelp();
  const isOpenEnrollmentChatOptionEnabled = useBoolVariation(Flag.OPEN_ENROLLMENT_CHAT_OPTION_ENABLED, false);
  const newBillUploadUIEnabled = useBoolVariation(Flag.NEW_BILL_UPLOAD_UI, false);
  return <WidgetWrapper title="Get help" wrapperProps={{
    px: "$0"
  }} titleProps={{
    px: "$5",
    pb: "$2"
  }} removeDivider data-sentry-element="WidgetWrapper" data-sentry-component="GetHelpPrompts" data-sentry-source-file="GetHelpPrompts.tsx">
      <GetHelpPrompt title="Get help with a bill" description="We check bills for overcharges/errors, then work to lower them." badge={<BillHelpBadge />} onPress={() => pushGetHelp({
      caseType: newBillUploadUIEnabled ? "BILL_ISSUE_V2" : "BILL_ISSUE",
      title: "Get help with a bill",
      source: "home_get_help_prompts_bill"
    })} data-sentry-element="GetHelpPrompt" data-sentry-source-file="GetHelpPrompts.tsx" />
      <Separator borderColor="$strokeSecondary" mx="$4" data-sentry-element="Separator" data-sentry-source-file="GetHelpPrompts.tsx" />
      <GetHelpPrompt title="Check my coverage" description="Get instant, personalized answers on your insurance questions." badge={<CoverageCheckBadge />} onPress={() => pushGetHelp({
      caseType: "BENEFITS_QUESTION",
      title: "Check my coverage",
      source: "home_get_help_prompts_benefits"
    })} data-sentry-element="GetHelpPrompt" data-sentry-source-file="GetHelpPrompts.tsx" />
      {isOpenEnrollmentChatOptionEnabled ? <>
          <Separator borderColor="$strokeSecondary" mx="$4" />
          <GetHelpPrompt title="Check my open enrollment" description="Get instant, personalized answers on your insurance questions." badge={<OpenEnrollmentBadge />} labelBadge={<XStack backgroundColor="$green10" px="$1.5" br="$2">
                <Paragraph2 color="$background" bold>
                  New
                </Paragraph2>
              </XStack>} onPress={() => pushGetHelp({
        caseType: "OPEN_ENROLLMENT",
        title: "Open enrollment help",
        source: "home_get_help_prompts_open_enrollment"
      })} />
        </> : null}
      <Separator borderColor="$strokeSecondary" mx="$4" data-sentry-element="Separator" data-sentry-source-file="GetHelpPrompts.tsx" />
      <GetHelpPrompt title="Something else" description="We'll help you find any answer. Share what you need." badge={<SomethingElseBadge />} onPress={() => pushGetHelp({
      caseType: "OTHER",
      title: "How can we help you?",
      source: "home_get_help_prompts_other"
    })} data-sentry-element="GetHelpPrompt" data-sentry-source-file="GetHelpPrompts.tsx" />
    </WidgetWrapper>;
}